import { PhotoCartGroup, CartItemApiResponse } from "./types";

export function formatPrice(amount: any, currency: string): string {
  // Simple currency formatting
  const symbols: { [key: string]: string } = {
    'USD': '$',
    'GBP': '£',
    'EUR': '€',
    'AUD': '$',
    'CAD': '$'
  };
  
  const symbol = symbols[currency] || currency;
  const numericAmount = parseFloat(amount) || 0;
  return `${symbol}${numericAmount.toFixed(2)}`;
}

// Utility function to group cart items by photo_id
export function groupCartItemsByPhoto(items: CartItemApiResponse[]): PhotoCartGroup[] {
  const grouped = items.reduce((acc, item) => {
    const photoId = item.photoId;
    
    if (!acc[photoId]) {
      acc[photoId] = {
        photo: {
          id: photoId,
          thumbnailUrl: "", // Will be populated from first item with photo data
          videoAsset: false,
          mediaType: ""
        },
        sales: []
      };
    }
    
    // If this item has photo data, use it to populate the photo object
    if (item.photo) {
      acc[photoId].photo = {
        id: item.photo.id,
        thumbnailUrl: item.photo.thumbnailUrl,
        videoAsset: item.photo.videoAsset,
        mediaType: item.photo.mediaType
      };
    }
    
    // Add the sale item
    acc[photoId].sales.push({
      id: item.id,
      productType: item.productType,
      printProductId: item.printProductId,
      printProductName: item.printProductName,
      photoId: item.photoId,
      eventId: item.eventId || 0, // Provide default if missing
      quantity: item.quantity || 1,
      totalPrice: parseFloat(item.totalPrice || "0"),
      currency: item.currency,
      purchased: item.purchased,
      digitalDownloadDisabled: item.digitalDownloadDisabled
    });
    
    return acc;
  }, {} as { [key: number]: PhotoCartGroup });
  
  return Object.values(grouped);
}